// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"72":"9305e070","280":"94638010","484":"a7558cbc"}[chunkId] + ".chunk.css");